module.exports = __webpack_public_path__ + "static/img/banner.3ba0834.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/banner.png
// module id = NUvA
// module chunks = 1